import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { api } from '../constants/api'

const ActivityLogs = () => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [data, setData] = useState([])



    const getAllActivity = async () => {
        try {
            setLoading(true)
            setError('')
            let response = await api(true, `/admin/getActivityLogs`, 'get')
            setLoading(false)
            const data = response.data.data.map((activity: any) => {
                return {
                    ...activity,
                    dateTime: moment(activity.created_at).format('YYYY-MM-DD HH:mm')
                }
            })
            setData(data);
        } catch (error: any) {
            console.log(error, '<=== error loading activity logs...');
            setLoading(false);
            setError(error?.response?.data?.message || error.message);
            setData([]);
        }
    }

    useEffect(() => {
        getAllActivity();
    }, [])

    return (
        <div className="basePriceContainer">
            <h2 className="h2header basePrice">Activity Logs</h2>
            {error && (
                <p style={{ color: 'red' }}>{error}</p>
            )}
            <div className="table-responsive">
            <table className="tbl styled-table" border={1}>
                <thead>
                    <tr>
                        <th style={{minWidth: 150}}>
                            TYPE
                        </th>
                        <th style={{minWidth: 100}}>
                            SUB TYPE
                        </th>
                        <th style={{minWidth: 100}}>USER ID</th>
                        <th style={{minWidth: 100}}>RECORD ID</th>
                        <th style={{minWidth: 150}}>DATE TIME</th>
                        <th style={{minWidth: 200}}>MEMBER</th>
                    </tr>
                </thead>
                <tbody>
                    {loading && (
                        <tr>
                            <td colSpan={2}>
                                Loading...
                            </td>
                        </tr>
                    )}
                    {!loading && (
                        data.sort((a: any, b: any) => new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime()).map((item: any) => (
                            <tr key={item.id}>
                                <td>
                                    {item.type}
                                </td>
                                <td>
                                    {item.sub_type}
                                </td>
                                <td>{(item.admin_name !== '' && item.admin_name !== null) ? item.admin_name : item.admin_id }</td>
                                <td>{item.record_id}</td>
                                <td>{item.dateTime}</td>
                                <td>{item.target_user_name}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
            </div>
        </div>
    )
}

export default ActivityLogs
